/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:70c85dc6-1fd5-4699-b11a-cb587d47b93d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_BDO7nydTt",
    "aws_user_pools_web_client_id": "4vd8vbf78v3jq39p9t15anbqoo",
    "oauth": {},
    "aws_cognito_login_mechanisms": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://fyszvutevfcjrjpx7uziepfqom.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "SciHackRestApi",
            "endpoint": "https://agk6mldlx3.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "scihacke29934d9e28b4e1d94ea91ee46ecf9af92240-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
